<template>
    <div>
        <Header title="我的设备" memo="管理注意力测评设备信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div></div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-select v-model="query.state" @change="execQuery" :style="{ width: '200px' }">
                            <a-select-option value="">
                                所有设备
                            </a-select-option>
                            <a-select-option value="Pass">
                                已通过
                            </a-select-option>
                            <a-select-option value="Reject">
                                未通过
                            </a-select-option>
                            <a-select-option value="Wait">
                                未审核
                            </a-select-option>
                            <a-select-option value="NoBind">
                                未绑定
                            </a-select-option>
                            <a-select-option value="Use">
                                使用中
                            </a-select-option>
                            <a-select-option value="Idle">
                                空闲中
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" bordered :pagination="false">
            <a-table-column data-index="code" ellipsis width="300px">
                <span slot="title">设备标识</span>
                <template slot-scope="text, record">
                    <a-tag color="#2db7f5">
                        {{ record.sno }}
                    </a-tag>
                    {{ record.name }}
                    <a-popover placement="top" trigger="click">
                        <template slot="content">
                            <a-form-model layout="inline">
                                <a-form-model-item>
                                    <a-input v-model="editName" :placeholder="record.name">
                                        <a-icon slot="prefix" type="book" style="color:rgba(0,0,0,.25)" />
                                    </a-input>
                                </a-form-model-item>
                                <a-form-model-item>
                                    <a-button icon="save" @click="doEditName(record.id)">
                                        修改名称
                                    </a-button>
                                </a-form-model-item>
                            </a-form-model>
                        </template>
                        <template slot="title">
                            <span>修改设备名称</span>
                        </template>
                        <a-icon type="edit" style="color: green" />
                    </a-popover>
                </template>
            </a-table-column>
            <a-table-column data-index="info" ellipsis>
                <span slot="title">设备信息</span>
                <template slot-scope="text, record">
                    <a-tag color="#87d068" v-if="record.exam">
                        支持测评
                    </a-tag>
                    <a-tag color="#108ee9" v-if="record.exer">
                        支持训练
                    </a-tag>
                    <a-tag color="#009999" v-if="record.type === 'Unit'">
                        机构类型
                    </a-tag>
                    <a-tag color="#663300" v-if="record.type === 'Home'">
                        家庭类型
                    </a-tag>
                    <a-tag color="#CC7160" v-if="record.type === 'Both'">
                        兼容类型
                    </a-tag>
                </template>
            </a-table-column>
            <a-table-column data-index="emp" ellipsis width="200px">
                <span slot="title">关联员工</span>
                <template slot-scope="text, record">
                    已关联 [ {{ record.emp.length }} ] 名员工
                    <a-icon type="user" style="color: orange" @click="showCtaForm(record)" />
                </template>
            </a-table-column>
            <a-table-column data-index="state" ellipsis width="150px">
                <span slot="title">设备状态</span>
                <template slot-scope="text, record">
                    <a-popover placement="top" v-if="record.state === 'Use'">
                        <template slot="content">
                            <p>
                                编号：
                                <span>{{ record.use.id }}</span>
                            </p>
                            <p>
                                名称：
                                <span>{{ record.use.name }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>测评用户</span>
                        </template>
                        <span style="color:tomato;">使用中</span>
                    </a-popover>
                    <a-tag color="#2db7f5" v-if="record.state === 'Idle'">空闲中</a-tag>
                </template>
            </a-table-column>
            <a-table-column data-index="last" ellipsis width="180px">
                <span slot="title">最近测评</span>
                <template slot-scope="text, record">
                    {{ record.last.time || '尚未测评' }}
                </template>
            </a-table-column>
        </a-table>
        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <CtaComp title="设置关联员工" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></CtaComp>
    </div>
</template>

<script>
import CtaComp from './CtaComp'

export default {
    name: 'AteUnitDevice',
    components: {
        CtaComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        }
    },
    data() {
        return {
            query: {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                state: ''
            },
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            view: false,
            form: false,
            now: {},
            editName: ''
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '我的设备'])
        this.doLoad()
    },
    methods: {
        doLoad() {
            this.$http
                .get('/cts/ate/device/mgr/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },

        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                state: ''
            }
            this.doLoad()
        },
        doEditName(did) {
            if (!this.editName) {
                this.$message.error('请填写新名称')
                return
            }
            this.$http
                .post('/cts/ate/device/mgr/rename', {
                    id: did,
                    name: this.editName
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('修改成功')
                        this.editName = ''
                        this.doLoad()
                    }
                })
        },
        showCtaForm(item) {
            this.now = item
            this.form = true
        }
    }
}
</script>
